// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C7cvR","footer":"styles_footer__NTkZg"};